import { type Maybe } from '@models/Maybe';
import { type ComponentSourceRaw } from '@gql/graphql';

export type { ComponentSourceRaw };

export interface ComponentVendor {
    id: string;
    name: string;
    ifa: Maybe<string>;
    description: Maybe<string>;
}

export interface ComponentWithSources {
    id: string;
    name: string;
    version: string;
    isValid: boolean;
    eolReached: boolean;
    eolDate: Maybe<string>;
    cpeName: Maybe<string>;
    monitoredSince: Maybe<string>;
    url: Maybe<string>;
    securityUrl: Maybe<string>;
    componentVendor: ComponentVendor;
    createTime: Maybe<string>;
    updateTime: Maybe<string>;
    sourcesData: ComponentSourceRaw[];
}

export interface AffectedComponent {
    id: string;
    name: string;
    version: string;
    componentVendor: ComponentVendor;
    eolDate: Maybe<string>;
    eolReached: boolean;
    monitoredSince: Maybe<string>;
    cpeName: Maybe<string>;
    hasAssessment: boolean;
    sourcesData: ComponentSourceRaw[];
}

export interface AffectedComponentRow {
    vendorSource: string;
    componentSource: string;
    versionSource: string;
    identifierSource: string;
    vendor: string;
    component: string;
    version: string;
    identifier: Maybe<string>;
    eolReached: boolean;
    eolDate: Maybe<string>;
    monitoredSince: Maybe<string>;
    hasAssessment: boolean;
}

export interface CveSourceTileData {
    id: string;
    sourceName: string;
    updatedAt: Maybe<string>;
    cvssScore: Maybe<number>;
    cvssVector: Maybe<string>;
    cwe: Maybe<string>;
    description: string;
}

export enum CvssVersionLabel {
    V40 = 'CVSS v4.0',
    V31 = 'CVSS v3.1',
    V30 = 'CVSS v3.0',
    V2 = 'CVSS v2',
}

export interface CveCvssVersionScore {
    version: CvssVersionLabel;
    overallScore: Maybe<number>;
    baseScore: Maybe<number>;
    impact: Maybe<number>;
    exploitability: Maybe<number>;
    temporalScore: Maybe<number>;
    environmental: Maybe<number>;
    modifiedImpact: Maybe<number>;
    vector: Maybe<string>;
}

export interface CveDetailsData {
    code: string;
    publishedDate: Maybe<string>;
    title: string;
    sourcesData: CveSourceTileData[];
    cvssScoresBySourceId: Record<string, CveCvssVersionScore[]>;
    affectedComponents: AffectedComponent[];
}
